import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  Typography,
  useTheme
} from "@mui/material";

// Confirms the building or vehicle an upload from an entity slideout adds
// its emissions to, before the first confirm (commit-lines and
// csv-start-bulk-commit both refuse without it).
const SmartUploadSlideoutPrompt = ({ entityName, onCancel, onConfirm }) => {
  const { palette } = useTheme();

  return (
    <Dialog open onClose={onCancel} maxWidth="xs" fullWidth>
      <DialogContent>
        <Typography variant="body1">
          You&apos;re about to add these emissions to &apos;{entityName}
          &apos; — is that correct?
        </Typography>
      </DialogContent>
      <DialogActions>
        <Button onClick={onCancel}>Go back</Button>
        <Button
          variant="contained"
          color="secondary"
          sx={{ color: palette.common.white }}
          onClick={onConfirm}
        >
          Yes, add them
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default SmartUploadSlideoutPrompt;
